import axios from "axios";

// Dedicated httpClient for Reva
const revaClient = (apiKey) => {
  const instance = axios.create({
    baseURL: "https://admin.reva.la/api/external/customer",
    headers: {
      Authorization: `Bearer ${apiKey}`,
      "Content-Type": "application/json",
    },
  });


  instance.interceptors.response.use(
    (response) => [null, response.data],
    (error) => [error, null]
  );

  return instance;
};

export default {
    getMe: (apiKey) => revaClient(apiKey).post("/me"),
    getAccounts: (apiKey) => revaClient(apiKey).post("/accounts"),
    
    // Lineups (Entities)
    syncLineup: (apiKey, data) => revaClient(apiKey).post("/entities", {
        external_entity_id: data.external_entity_id,
        name: data.name,
        external_relationship_id: data.external_relationship_id,
        external_display_name: data.external_display_name,
        contact_info: data.contact_info
    }),
    getLineups: (apiKey) => revaClient(apiKey).get("/entities"),
    getLineup: (apiKey, lineupId) => revaClient(apiKey).get(`/entities/${lineupId}`),
    getLineupBalance: (apiKey, lineupId) => revaClient(apiKey).get(`/entities/${lineupId}/balance`),
    getLineupTransactions: (apiKey, lineupId) => revaClient(apiKey).get(`/entities/${lineupId}/transactions`),
    
    // Players (Individuals)
    syncPlayer: (apiKey, lineupId, data) => revaClient(apiKey).post(`/entities/${lineupId}/individuals`, {
        external_individual_id: data.player_id,
        name: data.player_name,
        external_display_name: data.external_display_name,
        contact_info: data.contact_info
    }),
    getPlayers: (apiKey, lineupId) => revaClient(apiKey).get(`/entities/${lineupId}/individuals`),
    getPlayerBalance: (apiKey, lineupId, playerId) => revaClient(apiKey).get(`/entities/${lineupId}/individuals/${playerId}/balance`),
    
    // Debts & Payments (Agnostic charging base on Accountable)
    createDebt: (apiKey, fansburyId, data) => revaClient(apiKey).post(`/entities/${fansburyId}/debts`, {
        ...data,
        origin: data.origin // { id, type, name }
    }),
    createPlayerDebt: (apiKey, lineupId, playerId, data) => revaClient(apiKey).post(`/entities/${lineupId}/individuals/${playerId}/debts`, {
        ...data,
        origin: data.origin
    }),
    applyTemplateCharge: (apiKey, fansburyId, templateIdOrSku, origin = null) => 
        revaClient(apiKey).post(`/entities/${fansburyId}/apply-charge/${templateIdOrSku}`, { origin }),
    applyPlayerTemplateCharge: (apiKey, lineupId, playerId, templateIdOrSku, origin = null) => 
        revaClient(apiKey).post(`/entities/${lineupId}/individuals/${playerId}/apply-charge/${templateIdOrSku}`, { origin }),
    uploadPayment: (apiKey, fansburyId, data) => revaClient(apiKey).post(`/entities/${fansburyId}/payments`, data),
    
    // Invoices & New Payments
    getInvoices: (apiKey, fansburyId) => revaClient(apiKey).get(`/entities/${fansburyId}/invoices`),
    getPlayerInvoices: (apiKey, lineupId, playerId) => 
        revaClient(apiKey).get(`/entities/${lineupId}/individuals/${playerId}/invoices`),
    
    registerInvoicesPayment: (apiKey, fansburyId, data) => 
        revaClient(apiKey).post(`/entities/${fansburyId}/register-invoices-payment`, data),
    registerPlayerInvoicesPayment: (apiKey, lineupId, playerId, data) => 
        revaClient(apiKey).post(`/entities/${lineupId}/individuals/${playerId}/register-invoices-payment`, data),
        
    registerAddBalance: (apiKey, fansburyId, data) => 
        revaClient(apiKey).post(`/entities/${fansburyId}/register-add-balance`, data),
    registerPlayerAddBalance: (apiKey, lineupId, playerId, data) => 
        revaClient(apiKey).post(`/entities/${lineupId}/individuals/${playerId}/register-add-balance`, data),

    // Summaries
    getDebtSummary: (apiKey) => revaClient(apiKey).get("/debt-summary"),
    getIncomeSummary: (apiKey) => revaClient(apiKey).get("/income-summary"),
    getSiloBalances: (apiKey, params = {}) => revaClient(apiKey).get("/silo-balances", { params }),
    getTransactionsSummary: (apiKey) => revaClient(apiKey).get("/transactions-summary"),

    // Price List (Charge Templates)
    getPriceList: (apiKey, tournamentId) => revaClient(apiKey).get(`/charge-templates?external_relationship_id=${tournamentId}`),
    savePriceItem: (apiKey, data) => revaClient(apiKey).post("/charge-templates", {
        external_relationship_id: data.external_relationship_id,
        sku: data.sku,
        name: data.description,
        amount: data.price,
        type: data.type || "other",
        description: data.description
    }),
    deletePriceItem: (apiKey, id) => revaClient(apiKey).delete(`/charge-templates/${id}`),
};
